var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section shop"},[_c('div',{staticClass:"inner"},[_c('div',{staticClass:"title"},[_vm._v("ONLINE SHOP")]),_c('div',{staticClass:"button",on:{"click":_vm.goUrl}},[_vm._v("SET OUT")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }